import { render, staticRenderFns } from "./areaModel.vue?vue&type=template&id=59a27ddd&scoped=true&"
import script from "./areaModel.vue?vue&type=script&lang=js&"
export * from "./areaModel.vue?vue&type=script&lang=js&"
import style0 from "./areaModel.vue?vue&type=style&index=0&id=59a27ddd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a27ddd",
  null
  
)

export default component.exports